export const Locale = {
  EN_GB: 'en_GB',
  EN: 'en',
  NB_NO: 'nb_NO',
  NO: 'no',
  DE_DE: 'de_DE',
  DE: 'de',
};

Object.freeze(Locale);
